module.exports = __webpack_public_path__ + "static/media/lexus-phone.0f36da29.svg";